import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';

const QUICK_ACTIONS = [
  {
    id: 'explore-investments',
    label: 'Explore Investments',
    description: 'Discover new opportunities',
    icon: 'TrendingUp',
    path: '/investment-opportunities',
    membershipRequired: false,
  },
  {
    id: 'view-portfolio',
    label: 'My Portfolio',
    description: 'Track your performance',
    icon: 'PieChart',
    path: '/portfolio-tracker',
    membershipRequired: false,
  },
  {
    id: 'join-community',
    label: 'Community Hub',
    description: 'Connect with members',
    icon: 'Users',
    path: '/community-hub',
    membershipRequired: false,
  },
  {
    id: 'marketplace',
    label: 'Marketplace',
    description: 'Women-owned businesses',
    icon: 'ShoppingBag',
    path: '/win-marketplace-products',
    membershipRequired: false,
  },
];

export default function DashboardQuickActions({ membershipTier = 'standard', className = '' }) {
  const navigate = useNavigate();

  const handleActionClick = (action) => {
    if (action?.membershipRequired && membershipTier === 'free') {
      return;
    }
    navigate(action?.path);
  };

  return (
    <section className={`${className}`} aria-label="Quick actions">
      <div className="flex items-center justify-between mb-4">
        <h3
          className="font-heading font-semibold text-foreground"
          style={{ fontSize: '1.25rem' }}
        >
          Quick Actions
        </h3>
        <span
          className="font-caption text-muted-foreground"
          style={{ fontSize: '0.8125rem' }}
        >
          Jump to any section
        </span>
      </div>
      <div className="quick-action-grid">
        {QUICK_ACTIONS?.map((action, index) => {
          const isLocked = action?.membershipRequired && membershipTier === 'free';

          return (
            <button
              key={action?.id}
              className={`quick-action-card animate-fade-in-up ${isLocked ? 'opacity-60 cursor-not-allowed' : ''}`}
              style={{ animationDelay: `${index * 75}ms` }}
              onClick={() => handleActionClick(action)}
              disabled={isLocked}
              aria-label={`${action?.label}${isLocked ? ' - Premium membership required' : ''}`}
              aria-disabled={isLocked}
            >
              <div className="quick-action-icon">
                {isLocked ? (
                  <Icon name="Lock" size={22} color="var(--color-accent)" strokeWidth={1.75} />
                ) : (
                  <Icon name={action?.icon} size={22} color="var(--color-accent)" strokeWidth={1.75} />
                )}
              </div>
              <div>
                <div
                  className="font-caption font-medium text-foreground leading-tight"
                  style={{ fontSize: '0.875rem' }}
                >
                  {action?.label}
                </div>
                <div
                  className="font-caption text-muted-foreground mt-1"
                  style={{ fontSize: '0.75rem' }}
                >
                  {isLocked ? 'Premium required' : action?.description}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}